import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { fetchProductById, addToCart } from "../services/api";
import "./ProductDetail.css";
import axios from "axios";

import { API_URL } from "../services/api";

const ProductDetail = () => {
  const { productId } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [businessName, setBusinessName] = useState("");
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [currentImages, setCurrentImages] = useState([]);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [notification, setNotification] = useState({
    show: false,
    type: "",
    message: "",
    action: null,
  });

  const decodeHtmlEntities = (text) => {
    if (!text) return text;

    // Create a temporary div element to decode HTML entities
    const textarea = document.createElement("textarea");
    textarea.innerHTML = text;
    return textarea.value;
  };

  useEffect(() => {
    const fetchProductData = async () => {
      try {
        setLoading(true);
        const data = await fetchProductById(productId);
        setProduct(data);

        // Set default variant if available
        if (data.variants && data.variants.length > 0) {
          setSelectedVariant(data.variants[0]);

          // Set images based on variant or product
          if (data.variants[0].images && data.variants[0].images.length > 0) {
            setCurrentImages(data.variants[0].images);
          } else if (data.images && data.images.length > 0) {
            setCurrentImages(data.images);
          } else if (data.image) {
            // Legacy support for old products with single image
            setCurrentImages([
              { id: "main", image: data.image, alt_text: data.name },
            ]);
          }
        } else {
          // No variants, use product images
          if (data.images && data.images.length > 0) {
            setCurrentImages(data.images);
          } else if (data.image) {
            setCurrentImages([
              { id: "main", image: data.image, alt_text: data.name },
            ]);
          }
        }

        // Fetch business and related products after getting product data
        if (data.business) {
          fetchBusinessDetails(data.business);
          fetchRelatedProducts(data.business, data.id);
        }

        setLoading(false);
      } catch (error) {
        console.error("Error fetching product:", error);
        setLoading(false);
      }
    };

    fetchProductData();
  }, [productId]);

  // Auto-hide notification after 5 seconds
  useEffect(() => {
    let timer;
    if (notification.show) {
      timer = setTimeout(() => {
        setNotification((prev) => ({ ...prev, show: false }));
      }, 5000);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [notification.show]);

  const fetchBusinessDetails = async (businessId) => {
    try {
      const response = await axios.get(`${API_URL}api/business/${businessId}/`);
      setBusinessName(response.data.name);
    } catch (error) {
      console.error("Failed to fetch business details:", error);
    }
  };

  // const fetchRelatedProducts = async (businessId, currentProductId) => {
  //   try {
  //     const response = await axios.get(`${API_URL}api/products-by-business/${businessId}/`);
  //     // Filter out the current product and limit to 3 products
  //     const filteredProducts = response.data
  //       .filter(product => product.id !== currentProductId)
  //       .slice(0, 3);
  //     setRelatedProducts(filteredProducts);
  //   } catch (error) {
  //     console.error("Failed to fetch related products:", error);
  //   }
  // };

  const fetchRelatedProducts = async (businessId, currentProductId) => {
    try {
      const response = await axios.get(
        `${API_URL}api/products-by-business/${businessId}/`
      );

      const productsArray = response.data.results;

      if (Array.isArray(productsArray)) {
        const filteredProducts = productsArray
          .filter((product) => product.id !== currentProductId)
          .slice(0, 3);
        setRelatedProducts(filteredProducts);
      } else {
        console.warn(
          "Expected 'results' to be an array, but got:",
          productsArray
        );
        setRelatedProducts([]);
      }
    } catch (error) {
      console.error("Failed to fetch related products:", error);
    }
  };

  const handleVariantSelect = (variant) => {
    setSelectedVariant(variant);
    setSelectedImageIndex(0); // Reset to first image when changing variant

    // Update images based on selected variant
    if (variant.images && variant.images.length > 0) {
      setCurrentImages(variant.images);
    } else if (product.images && product.images.length > 0) {
      // Fall back to product images if variant has no images
      setCurrentImages(product.images);
    } else if (variant.image) {
      // Legacy support for old variants with single image
      setCurrentImages([
        { id: "main", image: variant.image, alt_text: product.name },
      ]);
    } else if (product.image) {
      // Legacy support for old products with single image
      setCurrentImages([
        { id: "main", image: product.image, alt_text: product.name },
      ]);
    }
  };

  const handleImageSelect = (index) => {
    setSelectedImageIndex(index);
  };

  const handleAddToCart = async () => {
    const token = localStorage.getItem("access_token");

    if (!token) {
      localStorage.setItem("product_redirect", `/shop/products/${productId}`);
      // Show notification and prepare for redirect
      setNotification({
        show: true,
        type: "error",
        message: "You must be logged in to add items to your cart",
        action: {
          label: "Login Now",
          handler: () => navigate("/login"),
        },
      });

      // Auto-redirect after 3 seconds
      setTimeout(() => {
        navigate("/login");
      }, 3000);

      return;
    }

    try {
      const variantId = selectedVariant ? selectedVariant.id : null; // Send variant ID if selected
      const response = await addToCart(productId, token, variantId);

      // Show success notification
      setNotification({
        show: true,
        type: "success",
        message: "Product added to cart successfully!",
        action: {
          label: "View Cart",
          handler: () => navigate("/cart"),
        },
      });

      // console.log(response);
    } catch (error) {
      // Show error notification
      if (error.response && error.response.status === 401) {
        localStorage.setItem("product_redirect", `/shop/products/${productId}`);
        setNotification({
          show: true,
          type: "error",
          message: "You must be logged in to add items to your cart",
          action: {
            label: "Login Now",
            handler: () => navigate("/login"),
          },
        });
      }
      // setNotification({
      //   show: true,
      //   type: 'error',
      //   message: 'Failed to add product to cart, please log in!',
      //   action: null
      // });
    }
  };

  const closeNotification = () => {
    setNotification((prev) => ({ ...prev, show: false }));
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
      </div>
    );
  }

  if (!product) {
    return <div className="error-message">Product not found</div>;
  }

  return (
    <div className="product-page-container">
      {/* Notification Component */}
      {notification.show && (
        <div className={`notification-popup ${notification.type}`}>
          <div className="notification-content">
            <span className="notification-message">{notification.message}</span>
            <div className="notification-actions">
              {notification.action && (
                <button
                  className="notification-action-button"
                  onClick={notification.action.handler}
                >
                  {notification.action.label}
                </button>
              )}
              <button
                className="notification-close-button"
                onClick={closeNotification}
              >
                ×
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="product-detail-main">
        {/* Left column - Product Images */}
        <div className="product-images-container">
          <div className="main-image-container">
            <img
              src={
                currentImages[selectedImageIndex]?.image ||
                "/placeholder-image.jpg"
              }
              alt={
                decodeHtmlEntities(
                  currentImages[selectedImageIndex]?.alt_text
                ) || decodeHtmlEntities(product.name)
              }
              className="main-product-image"
            />
          </div>

          {/* Thumbnail Gallery */}
          {currentImages.length > 1 && (
            <div className="image-thumbnails">
              {currentImages.map((img, index) => (
                <img
                  key={img.id || index}
                  src={img.image}
                  alt={img.alt_text || `${product.name} - image ${index + 1}`}
                  className={`thumbnail ${
                    selectedImageIndex === index ? "selected-thumbnail" : ""
                  }`}
                  onClick={() => handleImageSelect(index)}
                />
              ))}
            </div>
          )}
        </div>

        {/* Right column - Product Info */}
        <div className="product-info-container">
          <div className="product-info-sticky">
            {/* <h1 className="product-title">{product.name}</h1> */}
            <h1 className="product-title">
              {decodeHtmlEntities(product.name)}
            </h1>
            <div className="product-price">
              <span className="price-label">Price:</span>
              <span className="price-value">
                ${selectedVariant?.price || product.price}
              </span>
            </div>
            <div className="business-link">
              <span>Sold by:</span>
              {businessName ? (
                <Link
                  to={`/businessproducts/${product.business}`}
                  className="business-name-link"
                >
                  {businessName}
                </Link>
              ) : (
                <span className="business-name-loading">Loading...</span>
              )}
            </div>
            <div className="product-condition">
              <span className="condition-label">Condition:</span>
              <span className="condition-value">
                {product.condition === "second_hand"
                  ? "Secondhand"
                  : product.condition === "new"
                  ? "New"
                  : product.condition}
              </span>
            </div>

            {/* Variant Selection */}
            {/* {product.variants && product.variants.length > 0 && (
              <div className="variant-selection">
                <p className="variant-label">Select Variant:</p>
                <div className="variant-buttons">
                  {product.variants.map((variant) => (
                    <button
                      key={variant.id}
                      className={`variant-btn ${selectedVariant?.id === variant.id ? 'selected' : ''}`}
                      onClick={() => handleVariantSelect(variant)}
                    >
                      {variant.option1} {variant.option2 ? ` - ${variant.option2}` : ""}
                    </button>
                  ))}
                </div>
              </div>
            )} */}

            {/* Variant Selection */}
            {/* {product.variants && product.variants.length > 0 && (
              <div className="variant-selection">
                <p className="variant-label">Select Variant:</p>

                {product.variants.length > 9 ? (
                  <select
                    className="variant-dropdown"
                    value={selectedVariant?.id || ""}
                    onChange={(e) => {
                      const variant = product.variants.find(v => v.id === e.target.value);
                      handleVariantSelect(variant);
                    }}
                  >
                    <option value="">Select a variant</option>
                    {product.variants.map((variant) => (
                      <option key={variant.id} value={variant.id}>
                        {variant.option1} {variant.option2 ? ` - ${variant.option2}` : ""}
                      </option>
                    ))}
                  </select>
                ) : (
                  <div className="variant-buttons">
                    {product.variants.map((variant) => (
                      <button
                        key={variant.id}
                        className={`variant-btn ${selectedVariant?.id === variant.id ? 'selected' : ''}`}
                        onClick={() => handleVariantSelect(variant)}
                      >
                        {variant.option1} {variant.option2 ? ` - ${variant.option2}` : ""}
                      </button>
                    ))}
                  </div>
                )}
              </div>


            )} */}
            {/* Variant Selection */}
            {product.variants && product.variants.length > 0 && (
              <div className="variant-selection">
                <p className="variant-label">Select:</p>

                {product.variants.length > 9 ? (
                  <select
                    className="variant-dropdown"
                    value={selectedVariant?.id || ""}
                    onChange={(e) => {
                      const variantId = e.target.value;
                      if (variantId) {
                        // Try to find variant with both string and number comparison
                        const variant = product.variants.find(
                          (v) =>
                            v.id == variantId ||
                            v.id === parseInt(variantId) ||
                            v.id === variantId
                        );
                        if (variant) {
                          handleVariantSelect(variant);
                        }
                      }
                    }}
                  >
                    <option value="">Select</option>
                    {product.variants.map((variant) => (
                      <option key={variant.id} value={variant.id}>
                        {variant.option1}{" "}
                        {variant.option2 ? ` - ${variant.option2}` : ""}
                      </option>
                    ))}
                  </select>
                ) : (
                  <div className="variant-buttons">
                    {product.variants.map((variant) => (
                      <button
                        key={variant.id}
                        className={`variant-btn ${
                          selectedVariant?.id === variant.id ? "selected" : ""
                        }`}
                        onClick={() => handleVariantSelect(variant)}
                      >
                        {variant.option1}{" "}
                        {variant.option2 ? ` - ${variant.option2}` : ""}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            )}

            <button className="add-to-cart-button" onClick={handleAddToCart}>
              Add to Cart
            </button>
          </div>

          <div className="product-description-section">
            <h2 className="section-title">Product Description</h2>
            {/* <div className="product-description">
              {product.description}
            </div> */}
            <div className="product-description">
              {decodeHtmlEntities(product.description)}
            </div>
          </div>
        </div>
      </div>

      {/* Related Products Section */}
      <div className="related-products-section">
        <h2 className="section-title">Other Products From {businessName}</h2>
        <div className="related-products-grid">
          {relatedProducts.map((relatedProduct) => (
            <Link
              to={`/shop/products/${relatedProduct.id}`}
              key={relatedProduct.id}
              className="related-product-card"
            >
              <div className="related-product-image-container">
                <img
                  // src={relatedProduct.image || (relatedProduct.images && relatedProduct.images.length > 0 ? relatedProduct.images[0].image : '/placeholder-image.jpg')}
                  src={relatedProduct.primary_image}
                  alt={relatedProduct.name}
                  className="related-product-image"
                />
              </div>
              <div className="related-product-info">
                <p className="related-product-name">{relatedProduct.name}</p>
                <p className="related-product-price">${relatedProduct.price}</p>
              </div>
            </Link>
          ))}

          {/* View Business Page Card */}
          <Link
            to={`/businessproducts/${product.business}`}
            className="view-business-card"
          >
            <div className="view-business-content">
              <h3>View All Products</h3>
              <p>See more from {businessName}</p>
              <span className="view-more-arrow">→</span>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
